var React = require('react');

function SearchIconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 6.83352C0 3.06552 3.06552 0 6.83352 0C10.6015 0 13.667 3.06552 13.667 6.83352C13.667 8.47216 13.0862 9.97624 12.1213 11.155L16 15.0338L15.0338 16L11.155 12.1213C9.97696 13.0862 8.47216 13.667 6.83352 13.667C3.06552 13.667 0 10.6015 0 6.83352ZM6.83352 1.3667C3.81926 1.3667 1.3667 3.81926 1.3667 6.83352C1.3667 9.84776 3.81926 12.3003 6.83352 12.3003C9.84776 12.3003 12.3003 9.84776 12.3003 6.83352C12.3003 3.81926 9.84776 1.3667 6.83352 1.3667Z"}));
}

SearchIconInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = SearchIconInline;

SearchIconInline.default = SearchIconInline;
